import { useContext } from "react";
import { RootContext } from "../RootContext";

const usePageState = () => useContext(RootContext).pageStateStore;

export default usePageState;
